var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_8091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80481 10.3047C8.12394 11.9877 6.17532 13.5963 5.40394 12.8249C4.30107 11.722 3.62107 10.7615 1.19007 12.7144C-1.24093 14.6694 0.626947 15.9699 1.69369 17.0388C2.92619 18.2713 7.52044 17.1047 12.0615 12.5635C16.6048 8.02244 17.7735 3.42819 16.541 2.19569C15.4721 1.12681 14.1695 -0.738934 12.2166 1.69207C10.2638 4.12094 11.2221 4.80094 12.325 5.90382C13.0964 6.67519 11.4878 8.62169 9.80481 10.3047Z",
    fill: "#266BEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_8091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
export default SvgPhone;